var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useEffect, useMemo, useState } from 'react';
import { FixedSizeList } from 'react-window';
import { useQueryClient } from '@tanstack/react-query';
import { TagType } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import FSButton from '@components/FSButton';
import Tags from '@shared/tags/Tags';
import Modal from '@shared/modal/Modal';
import Manager from '@shared/modal/Manager';
import ModalHeader from '@shared/modal/ModalHeader';
import { CheckBox, ThreeStateCheckBox } from '@shared/input/CheckBox';
import SelectInput from '@shared/input/SelectInput';
import { useTagContext } from '@data/tag/tagContext';
import { useMissingTags } from '@data/hooks/missingTags';
import { useDetectDimensions, useImportJobRows, useImportJobs } from '@data/importJob/importJobActions';
import { FormTextInput } from '@styled/Form';
import { ModalBody, ModalFooterStyled } from '@styled/Modal';
import { MissingTagsBox, MissingTagsHeader, MissingTagsHeaderItem, MissingTagsListRow } from '@styled/Import';
import { addMissingTags } from './importActions';
import { globalLoadingWrapped } from './util';
var MISSING_TAGS_ROW_SIZES = {
    height: 300,
    itemSize: 40,
    width: '100%',
};
function MissingTagRow(_a) {
    var data = _a.data, index = _a.index, style = _a.style;
    var item = data.items[index];
    if (item === undefined) {
        return null;
    }
    return (React.createElement(MissingTagsListRow, { style: style, key: "row_".concat(item.tagName) },
        React.createElement(CheckBox, { checked: item.selected, action: function () { return data.toggleSelected(index); } }),
        React.createElement("div", null, item.tagName),
        React.createElement(FormTextInput, { autoComplete: "off", type: "text", onChange: function (e) { return data.updateDescription(index, e.target.value); }, value: item.description }),
        React.createElement(Tags, { canUpdate: true, singleLine: true, select: function (tagId) { return data.addConnectedTag(index, tagId); }, remove: function (tagId) { return data.removeConnectedTag(index, tagId); }, tags: item.connectedTags, placeholder: data.L('Select Connection'), filterByTypes: [TagType.Dimension] })));
}
function getSelectedMapForMissingTags(missingTags) {
    var selectedMap = {};
    if (missingTags !== null) {
        for (var columnIndex in missingTags) {
            if (Object.prototype.hasOwnProperty.call(missingTags, columnIndex)) {
                var column = missingTags[Number.parseInt(columnIndex)];
                var selected = [];
                if (column !== undefined) {
                    for (var i = 0; i < column.tagNames.length; i++) {
                        selected[i] = true;
                    }
                }
                selectedMap[columnIndex] = selected;
            }
        }
    }
    return selectedMap;
}
export default function ImportMissingTagsModal(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var importJobId = _a.importJobId;
    var L = useLanguage().L;
    var queryClient = useQueryClient();
    var tagData = useTagContext().tagData;
    var columnMetas = (_d = (_c = (_b = useImportJobs({ notifyOnChangeProps: ['data'] }).data) === null || _b === void 0 ? void 0 : _b.find(function (importJob) { return importJob.id === importJobId; })) === null || _c === void 0 ? void 0 : _c.metadata.columnMetas) !== null && _d !== void 0 ? _d : [];
    var importJobRows = (_e = useImportJobRows(importJobId, { notifyOnChangeProps: ['data'] }).data) !== null && _e !== void 0 ? _e : [];
    var _l = __read(useState(0), 2), selectedColumnIndex = _l[0], setSelectedColumnIndex = _l[1];
    var _m = __read(useState({}), 2), connectedTags = _m[0], setConnectedTags = _m[1];
    var _o = __read(useState({}), 2), connectedTagsColumnIds = _o[0], setConnectedTagsColumnIds = _o[1];
    var _p = __read(useState({}), 2), descriptionColumnIds = _p[0], setDescriptionColumnIds = _p[1];
    var _q = __read(useState({}), 2), descriptions = _q[0], setDescriptions = _q[1];
    var missingTags = useMissingTags(columnMetas, importJobRows, tagData.tagById);
    var _r = __read(useState(function () {
        return getSelectedMapForMissingTags(missingTags);
    }), 2), selectedMap = _r[0], setSelectedMap = _r[1];
    useEffect(function () {
        if (Object.keys(missingTags).length === 0) {
            Manager.closeModal();
        }
        setSelectedMap(getSelectedMapForMissingTags(missingTags));
    }, [missingTags]);
    var detectDimensions = useDetectDimensions();
    var selectedColumn = missingTags[selectedColumnIndex];
    var items = (_f = selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.tagNames) !== null && _f !== void 0 ? _f : [];
    var selectedColumnTableTagRelations = (_h = tagData.relationsByTableTagId[(_g = selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.tableTagId) !== null && _g !== void 0 ? _g : -1]) !== null && _h !== void 0 ? _h : [];
    useEffect(function () {
        var missingTagsColumnIndices = Object.keys(missingTags).map(function (columnIndex) { return Number.parseInt(columnIndex); });
        if (!missingTagsColumnIndices.includes(selectedColumnIndex)) {
            setSelectedColumnIndex(Math.min.apply(Math, __spreadArray([], __read(missingTagsColumnIndices), false)));
        }
    }, [missingTags, selectedColumnIndex]);
    var columnHeaderNames = columnMetas.map(function (columnMeta) { return columnMeta.name; });
    var columnHeaderOptions = __spreadArray([
        { label: L('None'), value: null }
    ], __read(columnHeaderNames.map(function (headerName, idx) {
        return {
            label: headerName,
            value: idx,
        };
    })), false);
    function selectColumn(idx) {
        setSelectedColumnIndex(idx);
    }
    function selectAll(value) {
        var _a;
        var _b;
        var selectedCopy = __spreadArray([], __read(((_b = selectedMap[selectedColumnIndex]) !== null && _b !== void 0 ? _b : [])), false);
        for (var i = 0; i < selectedCopy.length; i++) {
            selectedCopy[i] = !value;
        }
        setSelectedMap(__assign(__assign({}, selectedMap), (_a = {}, _a[selectedColumnIndex] = selectedCopy, _a)));
    }
    function toggleSelected(rowIndex) {
        setSelectedMap(function (current) {
            var _a;
            var _b, _c;
            var columnSelectedCopy = __spreadArray([], __read(((_b = current[selectedColumnIndex]) !== null && _b !== void 0 ? _b : [])), false);
            columnSelectedCopy[rowIndex] = !((_c = current[selectedColumnIndex]) === null || _c === void 0 ? void 0 : _c[rowIndex]);
            return __assign(__assign({}, current), (_a = {}, _a[selectedColumnIndex] = columnSelectedCopy, _a));
        });
    }
    function changeDescriptionColumn(e) {
        var descriptionColumnIndex = e.target.value;
        if (typeof descriptionColumnIndex === 'undefined' || typeof descriptionColumnIndex === 'string') {
            // no options with undefined or string
            return;
        }
        // set selected column id to new value
        var descriptionColumnIdsCopy = __assign({}, descriptionColumnIds);
        descriptionColumnIdsCopy[selectedColumnIndex] = descriptionColumnIndex;
        setDescriptionColumnIds(descriptionColumnIdsCopy);
        // if "None" option is selected, set all descriptions to empty
        if (descriptionColumnIndex === null) {
            setDescriptions([]);
            return;
        }
        // get list of missing tags that are being created
        var selectedColumn = missingTags[selectedColumnIndex];
        if (!selectedColumn) {
            // current missing tags column not found
            setDescriptions([]);
            return;
        }
        // map descriptions
        var descriptionColMap = {};
        for (var i = 0; i < importJobRows.length; i++) {
            // read values from import job rows
            var rowData = importJobRows[i].data;
            var desc = rowData[descriptionColumnIndex];
            // key = "missing tags" column text, value = "description" column text
            descriptionColMap[String(rowData[selectedColumnIndex]).trim()] =
                typeof desc === 'string' ? desc.trim() : String(desc);
        }
        // map missing tags names to descriptions
        var newDescriptions = __assign({}, descriptions);
        newDescriptions[selectedColumnIndex] = selectedColumn.tagNames.map(function (missingTagName) { var _a; return (_a = descriptionColMap[missingTagName]) !== null && _a !== void 0 ? _a : ''; });
        setDescriptions(newDescriptions);
    }
    function updateDescription(index, value) {
        var _a;
        var newDescriptions = __assign({}, descriptions);
        var colDescriptions = (_a = newDescriptions[selectedColumnIndex]) !== null && _a !== void 0 ? _a : [];
        colDescriptions[index] = value;
        newDescriptions[selectedColumnIndex] = colDescriptions;
        setDescriptions(newDescriptions);
    }
    function changeConnectedTagsColumn(e) {
        var targetValue = e.target.value;
        if (typeof targetValue === 'undefined' || typeof targetValue === 'string') {
            // no options with undefined or string
            return;
        }
        var selConnTagIds = __assign({}, connectedTagsColumnIds);
        selConnTagIds[selectedColumnIndex] = targetValue;
        setConnectedTagsColumnIds(selConnTagIds);
        if (targetValue === null) {
            setConnectedTags({});
            return;
        }
        var columnMeta = columnMetas[targetValue];
        if (columnMeta === undefined || columnMeta.tableTagId === undefined) {
            return;
        }
        if (selectedColumn === undefined) {
            return;
        }
        var connTagColMap = {};
        var _loop_1 = function (i) {
            var e_1, _a;
            var rowData = importJobRows[i].data;
            var tagName = String(rowData[targetValue]).toLowerCase().trim();
            var tagsByName = tagData.tagsByLowercase[tagName];
            if (tagsByName) {
                var ds_1 = tagData.downstreamTagIds.get(columnMeta.tableTagId);
                var tagsToAdd = tagsByName.filter(function (t) { return ds_1 === null || ds_1 === void 0 ? void 0 : ds_1.has(t.id); });
                var tagNameInColumn = String(rowData[selectedColumnIndex]).trim();
                if (connTagColMap[tagNameInColumn] === undefined) {
                    connTagColMap[tagNameInColumn] = new Set();
                }
                try {
                    for (var tagsToAdd_1 = (e_1 = void 0, __values(tagsToAdd)), tagsToAdd_1_1 = tagsToAdd_1.next(); !tagsToAdd_1_1.done; tagsToAdd_1_1 = tagsToAdd_1.next()) {
                        var tagToAdd = tagsToAdd_1_1.value;
                        connTagColMap[tagNameInColumn].add(tagToAdd);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (tagsToAdd_1_1 && !tagsToAdd_1_1.done && (_a = tagsToAdd_1.return)) _a.call(tagsToAdd_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        };
        for (var i = 0; i < importJobRows.length; i++) {
            _loop_1(i);
        }
        var newConnectedTags = __assign({}, connectedTags);
        newConnectedTags[selectedColumnIndex] = selectedColumn.tagNames.map(function (col, idx) {
            var connTagSet = connTagColMap[col];
            if (connTagSet) {
                var newConnectedTagsCol = newConnectedTags[selectedColumnIndex];
                if (newConnectedTagsCol && newConnectedTagsCol[idx]) {
                    return __spreadArray(__spreadArray([], __read(newConnectedTagsCol[idx]), false), __read(Array.from(connTagSet)), false);
                }
                return Array.from(connTagSet);
            }
            else {
                return [];
            }
        });
        setConnectedTags(newConnectedTags);
    }
    function addConnectedTag(index, tagId) {
        var _a;
        var newConnectedTags = __assign({}, connectedTags);
        var columnTags = (_a = newConnectedTags[selectedColumnIndex]) !== null && _a !== void 0 ? _a : [];
        if (!columnTags[index]) {
            columnTags[index] = [];
        }
        var tag = tagData.tagById[tagId];
        if (tag) {
            columnTags[index].push(tag);
        }
        newConnectedTags[selectedColumnIndex] = columnTags;
        setConnectedTags(newConnectedTags);
    }
    function removeConnectedTag(index, tagId) {
        var tag = tagData.tagById[tagId];
        if (!tag) {
            return;
        }
        var newConnectedTags = __assign({}, connectedTags);
        if (!newConnectedTags[selectedColumnIndex]) {
            return;
        }
        var columnTags = newConnectedTags[selectedColumnIndex];
        if (!columnTags) {
            return;
        }
        var rowTags = columnTags[index];
        if (!rowTags) {
            return;
        }
        var newRowTags = rowTags.filter(function (t) { return t.id !== tag.id; });
        columnTags[index] = newRowTags;
        setConnectedTags(newConnectedTags);
    }
    function addTagsForSelectedColumn() {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (selectedColumn === undefined) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, globalLoadingWrapped(function () { return __awaiter(_this, void 0, void 0, function () {
                                var _a, _b, _c;
                                return __generator(this, function (_d) {
                                    switch (_d.label) {
                                        case 0: return [4 /*yield*/, addMissingTags(importJobId, queryClient, selectedColumnTableTagRelations, {
                                                column: selectedColumn,
                                                descriptions: (_a = descriptions[selectedColumnIndex]) !== null && _a !== void 0 ? _a : [],
                                                connectedTags: (_b = connectedTags[selectedColumnIndex]) !== null && _b !== void 0 ? _b : [],
                                                selected: (_c = selectedMap[selectedColumnIndex]) !== null && _c !== void 0 ? _c : [],
                                            })];
                                        case 1:
                                            _d.sent();
                                            return [4 /*yield*/, detectDimensions.mutateAsync(importJobId)];
                                        case 2:
                                            _d.sent();
                                            setSelectedMap(function (current) {
                                                var _a;
                                                var _b;
                                                var selectedCopy = __spreadArray([], __read(((_b = current[selectedColumnIndex]) !== null && _b !== void 0 ? _b : [])), false);
                                                for (var i = 0; i < selectedCopy.length; i++) {
                                                    selectedCopy[i] = false;
                                                }
                                                return __assign(__assign({}, current), (_a = {}, _a[selectedColumnIndex] = selectedCopy, _a));
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    var checkboxValue = useMemo(function () {
        var selectedColumnSelectedMap = selectedMap[selectedColumnIndex];
        if (selectedColumnSelectedMap === undefined || selectedColumnSelectedMap.length === 0) {
            // no map found for this column
            return null;
        }
        // compare all values to first value
        var firstValue = selectedColumnSelectedMap[0];
        for (var i = 1; i < selectedColumnSelectedMap.length; i++) {
            if (selectedColumnSelectedMap[i] !== firstValue) {
                // array has both true and false values
                return null;
            }
        }
        // all values match with first value
        return firstValue;
    }, [selectedMap, selectedColumnIndex]);
    return (React.createElement(Modal, { width: '900', closeable: false },
        React.createElement(ModalHeader, { title: L('Create Missing Dimensions') }),
        React.createElement(ModalBody, null,
            React.createElement(MissingTagsHeader, null, columnHeaderNames.map(function (headerName, idx) {
                if (missingTags[idx] !== undefined) {
                    return (React.createElement(MissingTagsHeaderItem, { key: "filter-header-item-".concat(idx), "$active": idx === selectedColumnIndex, onClick: function () { return selectColumn(idx); } }, headerName));
                }
                else {
                    return null;
                }
            })),
            React.createElement(MissingTagsBox, null,
                React.createElement(MissingTagsListRow, null,
                    React.createElement(ThreeStateCheckBox, { action: function () { return selectAll(checkboxValue); }, value: checkboxValue, label: L('Select All') }),
                    React.createElement("div", null, L('Name')),
                    React.createElement(SelectInput, { name: "descriptionColumn", label: L('Description Column'), options: columnHeaderOptions, value: (_j = descriptionColumnIds[selectedColumnIndex]) !== null && _j !== void 0 ? _j : null, onChange: changeDescriptionColumn }),
                    React.createElement(SelectInput, { name: "connectedTagsColumn", label: L('Connected Dimensions Column'), options: columnHeaderOptions, value: (_k = connectedTagsColumnIds[selectedColumnIndex]) !== null && _k !== void 0 ? _k : null, onChange: changeConnectedTagsColumn })),
                React.createElement("hr", null),
                React.createElement(FixedSizeList, __assign({}, MISSING_TAGS_ROW_SIZES, { itemCount: items.length, itemData: {
                        items: items.map(function (tagName, itemIndex) {
                            var _a, _b, _c, _d, _e;
                            return ({
                                tagName: tagName,
                                description: (_b = (_a = descriptions[selectedColumnIndex]) === null || _a === void 0 ? void 0 : _a[itemIndex]) !== null && _b !== void 0 ? _b : '',
                                connectedTags: (_d = (_c = connectedTags[selectedColumnIndex]) === null || _c === void 0 ? void 0 : _c[itemIndex]) !== null && _d !== void 0 ? _d : [],
                                selected: !!((_e = selectedMap[selectedColumnIndex]) === null || _e === void 0 ? void 0 : _e[itemIndex]),
                            });
                        }),
                        L: L,
                        toggleSelected: toggleSelected,
                        updateDescription: updateDescription,
                        addConnectedTag: addConnectedTag,
                        removeConnectedTag: removeConnectedTag,
                    }, className: "tiny-scrollbars" }), MissingTagRow))),
        React.createElement(ModalFooterStyled, null,
            React.createElement(FSButton, { title: L('Cancel'), onClick: Manager.closeModal, "$type": "secondary" }),
            React.createElement(FSButton, { title: L('Create Dimensions'), onClick: function () { return addTagsForSelectedColumn(); } }))));
}
